import Drawable from '../entities/Drawable.js';
import { c } from '../setup.js';

export default class FlashScreen extends Drawable {
    constructor() {
        super();
        this.visible = true;
        this.alpha = 1;
        this.flashRadius = 24;
    }
    draw() {
        if (!this.visible) {
            return;
        }
        // Save the current canvas state
        c.save();

        // Create path for the full screen rectangle and cut out the circle
        c.beginPath();
        c.rect(0, 0, 240, 160);
        c.arc(120, 88, this.flashRadius, 0, Math.PI * 2, true); // The true parameter makes this subtract from the path

        // Fill with black
        c.fillStyle = `rgba(0, 0, 0, ${this.alpha})`;
        c.fill();

        // Restore the canvas state
        c.restore();
    }
}
